import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 18 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease: "easeOut", delay }}
    className={className}
  >
    {children}
  </motion.div>
);

export default function ArtAbout() {
  return (
    <div data-testid="art-about-page" className="bg-[#FBFAF6]">
      <section className="pt-20 lg:pt-32 pb-24 lg:pb-36">
        <div className="max-w-[820px] mx-auto px-6 sm:px-10">
          <Reveal>
            <Link
              to="/art"
              data-testid="art-about-back-link"
              className="inline-block text-[11px] uppercase tracking-[0.24em] text-[#55524C] hover:text-[#2F2C28] transition-colors"
            >
              ← Back to Collection
            </Link>
            <h1
              className="serif mt-10 tracking-tight text-[#2F2C28] leading-[1.05]"
              style={{ fontSize: "clamp(2.4rem, 5vw, 4.5rem)" }}
            >
              About <span className="italic">Anissa</span>
            </h1>
          </Reveal>

          <Reveal delay={0.1}>
            <img
              src="/images/anissa-portrait.jpg"
              alt="Anissa, artist and founder of Studio A, Bondi Beach"
              loading="lazy"
              decoding="async"
              className="mt-16 block w-full max-w-[560px] h-auto object-contain mx-auto"
            />
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-20 space-y-8 text-[18px] sm:text-[19px] leading-[1.95] text-[#2F2C28] serif">
              <p>There was a period in my life when nothing seemed to calm my mind.</p>
              <p>Almost without realising it, I started painting after work. It wasn't a plan, and it certainly wasn't to become an artist. It was simply something that made me feel a little quieter.</p>
              <p>I never went to art school. Everything I create has been self-taught — through curiosity, mistakes, and simply showing up to the canvas.</p>
              <p>For a long time, my paintings stayed behind closed doors. I was my own biggest critic and never imagined anyone else would see them. But as the years passed, I realised something unexpected.</p>
              <p>Painting was teaching me to let go of perfection.</p>
              <p>It became a place where I could express things I hadn't yet found the words for. Sometimes feelings I didn't even realise I was carrying, until they appeared on the canvas.</p>
              <p>When I finally shared my work, people began telling me they saw themselves in the paintings. Some found comfort, some found questions, and others simply felt understood.</p>
              <p>That reminded me that art doesn't need to have one meaning. It simply needs to make you feel something.</p>
              <p>Today, painting has become much more than an after-hours hobby. It's another extension of Studio A.</p>
              <p>Just like my treatments, I hope my artwork invites people to slow down, reconnect with themselves, and perhaps discover something they didn't know was waiting to be seen.</p>
              <p>If one of my paintings allows someone to feel even a little less alone, then sharing it has been worth it.</p>
            </div>
            <p className="label-eyebrow mt-16">— Anissa</p>
          </Reveal>

          <Reveal delay={0.1}>
            <Link
              to="/art"
              data-testid="return-to-collection-link"
              className="inline-block mt-20 text-[11px] uppercase tracking-[0.28em] text-[#2F2C28] font-medium border-b border-[#2F2C28]/40 pb-2 hover:border-[#2F2C28] transition-colors"
            >
              Return to Collection →
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
